"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_TIME_FORMATS = void 0;
const DATE_TIME_FORMATS = exports.DATE_TIME_FORMATS = {
  DAY_MONTH_YEAR_HOUR_MINUTE: "DD/MM/YYYY HH:mm",
  YEAR_MONTH_DAY_HOUR_MINUTE_SECOND: "YYYY-MM-DD HH:mm:SS"
};